import React, { useEffect, useState } from "react"
import {
  BrowserRouter as Router,
  Route,
  Routes,
  useLocation,
  useNavigationType,
} from "react-router-dom"
import Layout from "./components/Layout"
import Home from "./pages/Home"
import Book from "./pages/Book"
import Artbreak from "./pages/Artbreak"
import Painting from "./pages/Painting"
import About from "./pages/About"
import Sessions from "./pages/Sessions"
import Support from "./pages/Support"
import ViewTransition from "./components/ViewTransition"
import AudioPlayer from "./components/AudioPlayer"

function App() {
  return (
    <Router>
      <AppContent />
      <AudioPlayer />
    </Router>
  )
}

function AppContent() {
  const location = useLocation()
  const navigationType = useNavigationType()
  const [transitionStage, setTransitionStage] = useState("fadeOut")
  const [showOverlay, setShowOverlay] = useState(false)

  useEffect(() => {
    if (navigationType !== "POP") {
      setShowOverlay(true)
      setTransitionStage("fadeIn")

      const timer = setTimeout(() => {
        setTransitionStage("fadeOut")
        setTimeout(() => {
          setShowOverlay(false)
        }, 1000)
      }, 2500)

      return () => clearTimeout(timer)
    }
  }, [location, navigationType])

  const getTransitionContent = (pathname) => {
    if (pathname === "/artbreak") {
      return (
        <img
          src="/images/ArtbreakLogo.PNG"
          alt="Artbreak"
          className="max-h-[200px] w-auto"
        />
      )
    }

    switch (pathname) {
      case "/book":
        return "W.T.F. is healing?"
      case "/painting":
        return "Technical problems"
      default:
        return pathname.slice(1).toUpperCase() || "HOME"
    }
  }

  return (
    <Layout>
      <ViewTransition
        isActive={showOverlay}
        transitionStage={transitionStage}
      />
      {showOverlay && (
        <div className={`view-transition-overlay ${transitionStage}`}>
          <div className="view-transition-content">
            {getTransitionContent(location.pathname)}
          </div>
        </div>
      )}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/book" element={<Book />} />
        <Route path="/artbreak" element={<Artbreak />} />
        <Route path="/painting" element={<Painting />} />
        <Route path="/about" element={<About />} />
        <Route path="/sessions" element={<Sessions />} />
        <Route path="/support" element={<Support />} />
      </Routes>
    </Layout>
  )
}

export default App
